import Vue from 'vue';
import Vuebar from 'vuebar';

import VueCompositionApi, { provide } from '@vue/composition-api';
import { plugin, useProjectTailwindColors } from '@ideavivat/vivat-2';
import { ObserveVisibility } from 'vue-observe-visibility';

import PrettyCheck from 'pretty-checkbox-vue/check';
import VueApexCharts from 'vue-apexcharts';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';

import CommonRichTableWithAxios from './components/CommonRichTableWithAxios.vue';

Vue.use(VueApexCharts);
Vue.use(plugin);
Vue.use(VueCompositionApi);
Vue.use(Vuebar);
Vue.directive('observe-visibility', ObserveVisibility);

Vue.component('apexchart', VueApexCharts);
Vue.component('PrettyCheck', PrettyCheck);
Vue.component('CommonRichTableWithAxios', CommonRichTableWithAxios);

(window as any).BUILD_NOTE = `${process.env.VUE_APP_BUILD_NOTE || 'HMR'}${(window as any).VIVAT_BUILD_NOTE || ''}`;
console.log('Build:', (window as any).BUILD_NOTE);

Vue.config.productionTip = false;

(window as any).Vue = Vue;

useProjectTailwindColors(true);

// Development // https://idea-vivat-dotify-front-develop.netlify.app/
if (process.env.NODE_ENV === 'development' && window.location.href.includes('develop.netlify.app')) {
  Vue.config.devtools = true;
}

// Staging // https://idea-vivat-dotify-front-staging.netlify.app/
// if (process.env.NODE_ENV !== 'development' && window.location.href.includes('staging.netlify.app')) {}

// Production // https://dotify.app/
// if (process.env.NODE_ENV !== 'development') {}

// Local with process.env.VUE_APP_LOCAL_METRIC_SERVICE
// if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_LOCAL_METRIC_SERVICE) {}

new Vue({
  setup() {
    return {};
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
